import { Button } from 'components/core';
import { useProceedToIteroCheckout } from 'reactQuery/mutations';
import { Styled } from '.';

import { Dispatch, SetStateAction } from 'react';
import { IteroProposalClient } from 'types';
import { ITeroCheckoutStates } from 'components/ITeroCheckout';
import { shouldDisplaySavings } from 'components/OrderSummary';
import { useI18n } from 'contexts/i18n';

export const RentalProposalSummary = ({
  orderStep,
  currentProposal,
  setProceedToCheckout,
}: {
  orderStep: 'checkout' | ITeroCheckoutStates;
  currentProposal: IteroProposalClient;
  setProceedToCheckout: Dispatch<SetStateAction<boolean>>;
}) => {
  const proceedToIteroCheckoutMutation = useProceedToIteroCheckout(
    currentProposal.proposalId,
    setProceedToCheckout
  );
  const i18n = useI18n();
  const redirectToContract = () => {
    proceedToIteroCheckoutMutation.mutate();
  };

  return (
    <Styled.SummaryContainer>
      <Styled.Summary>
        <Styled.SummaryItem>
          <Styled.SummaryTitle>{i18n['Summary']}</Styled.SummaryTitle>
        </Styled.SummaryItem>

        <Styled.SummaryItem>
          <div>{i18n['Proposal Number']}:</div>
          <div>
            {orderStep === 'checkout' ? (
              <div>{currentProposal.proposalName}</div>
            ) : (
              <Styled.ProposalLinkWrapper
                href={`/iteroscanners/proposals/${currentProposal.proposalName}?showproposal=1`}
              >
                {currentProposal.proposalName}
              </Styled.ProposalLinkWrapper>
            )}
          </div>
        </Styled.SummaryItem>

        <Styled.SummaryItem>
          <div>{i18n['Total Rental Price']}:</div>
          <div>{currentProposal.displayTotalAfterAdjustments}</div>
        </Styled.SummaryItem>

        {shouldDisplaySavings(currentProposal.displayAdjustmentTotal) && (
          <Styled.SummaryItem>
            <div>{i18n['Total Promotion/Discount Amount']}:</div>
            <div>
              <Styled.DiscountAmount>
                (-{currentProposal.displayAdjustmentTotal})
              </Styled.DiscountAmount>
            </div>
          </Styled.SummaryItem>
        )}

        <Styled.SummaryItem>
          <Styled.TotalPrice>
            {i18n['Recurring Monthly total']}:
            <Styled.TaxNote>({i18n['Exclusive of taxes']})</Styled.TaxNote>
          </Styled.TotalPrice>
          <Styled.TotalPrice>
            {currentProposal.lineitems[0].netUnitPrice}
          </Styled.TotalPrice>
        </Styled.SummaryItem>

        {orderStep === 'checkout' && (
          <Styled.ButtonWrapper>
            <Button
              size="sm"
              onClick={() => redirectToContract()}
              width="100%"
              loading={proceedToIteroCheckoutMutation.isLoading}
            >
              {i18n['Checkout']}
            </Button>
          </Styled.ButtonWrapper>
        )}
      </Styled.Summary>
    </Styled.SummaryContainer>
  );
};
